<template>
	<div class="wrap">
		<DelData ref="delDatas"></DelData>
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>学习教育</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="datatable">
				<div class="datas">
					<div class="selectbar">
						<div>
							<el-input 
								style="width: 200px;"
								size="small"
								v-model="getdata.title" 
								placeholder="输入名称查询"
								@input="getdata.page = 1;totalPage = 0;dataList();"></el-input>
						</div>
						<div>
							<el-button size="small" type="primary" @click="delAll">一键删除</el-button>
							<el-button size="small" type="primary" @click="$router.push({path:'/add_sjzj',query:{type:'add'}})">随机组卷</el-button>
							<el-button size="small" type="primary" @click="$router.push({path:'/add_sj',query:{type:'add'}})">新建试卷</el-button>
						</div>
					</div>
					<div class="selectdata">
						<myTables 
							:tableData="tableData"
							delkey="id"
							@selectList="selectList"
                            :tableHeader="tableHeader"
                            :loading="true" 
							:indexs="false"
							:selection="true">
						</myTables>
						<Page :totalPage="totalPage" :pageSize="10" @changedata="changedata"></Page>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { xxjy,dwgl } from '@/axios'
	import Page from '@/components/page.vue'
	import { Message } from 'element-ui'
	import DelData from '@/components/delToast.vue'
	import myTables from '@/components/tables/tables.vue'
	let that;
	export default{
		data(){
			return{
				getdata:{
					dwid: this.$store.state.user.userinfo.id,
					flag:this.$store.state.user.userinfo.flag,
					dwid2:this.$store.state.user.userinfo.dwid,
					title: "",
					difficulty: "",
					status: "",
					page: 1
				},
				delList:[],
				showlocal:false,
				tableData:[],
				totalPage:0,
				studyNum:0,
				studyTime:0,
				tableHeader: [     // 表头
					{prop: 'title', label: '试卷名称',width:''},
					{prop: 'count', label: '题目数'},
					{prop: 'total', label: '总分'},
					{prop: 'pass', label: '及格分'},
					{prop: 'duration', label: '考试时长',formatData: function (val) {
						return  val+'分钟'
					}},
					{prop: 'addtime', label: '创建时间',width:"110",formatData: function (val) {
						return  that.$changeTime(val)
					}},
					// 此处为操作栏，不需要可以删除，clickFun绑定此操作按钮的事件
					{
						prop: 'oper', label: '操作', fixed: 'right', width: '120',align:'center',
						oper: [
							{name: '编辑', style: {color:'#bb0000'}, clickFun: this.edit,show:true,limit:''},
							{name: '删除', style: {color:'#bb0000'}, clickFun: this.del,show:true,limit:''},
						]
					}
				]
			}
		},
		components:{Page,DelData,myTables},
		created(){that = this;},
		methods:{
			// 数据
			dataList(){
				xxjy.testList(that.getdata).then(res => {
					if(res.data.pagedata.length>0){
						that.tableData = res.data.pagedata;
						that.totalPage = res.data.count;
					}else{
						that.tableData = [];
						that.totalPage = 0;
					}
				})
			},
			// 关闭新建弹窗
			closeLocal(){
				that.showlocal = false;
				that.dataList();
			},
			// 分页查询
			changedata(current){
				that.getdata.page = current;
				that.dataList();
			},
			// 一键删除
			selectList(value){
				that.delList =value;
			},
			delAll(){
				if(that.delList.length == 0){
					Message.warning('请先选择要删除得数据')
				}else{
					that.delData();
				}
			},
			// 部分禁用删除
			selectEnable(row, rowIndex) {
				if (row.dwid == that.$store.state.user.userinfo.id) {
					return true
				}
			},
			//	删除操作
			delData(){
				that.$refs.delDatas.showToast(res => {
					if(res){
						xxjy.delTest({
							id:that.delList,
						}).then(res => {
							if(res.code == 200){
								Message({
									type: 'success',
									message: '删除成功!'
								})
							}else{
								Message({
									type: 'error',
									message: res.msg
								})
							}
							that.getdata.page = 1;
							that.dataList();
						})
					}
				})
			},
			// 删除
			del(data){
				that.delList = [];
				that.delList = [data.id];
				that.delData();
			},
			// 编辑
			edit(data){
				that.$router.push({
					path:'/add_sj',
					query:{
						id:data.id,
						type:'edit'
					}
				})
			},
			// 导出表格
			daochu(){
				dwgl.exportPartyOrgan(that.getdata);
			}
		},
		mounted() {
			that.$emit('selectTop',5)
			that.dataList();
		}
	}
</script>

<style lang="scss">
	.wrap{
		position: relative;
		height: 100%;
		width: 100%;
		.fengmian{
			width: 100px;
			height: 60px;
			object-fit: cover;
		}
		.zttit{
			font-size: 16px;
			font-weight: bold;
		}
		.textCount{
			font-size: 14px;
		}
		.intro{
			font-size: 14px;
		}
	}
</style>

